import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=19879fe5&scoped=true&"
import script from "./BasicLayout.vue?vue&type=script&lang=js&"
export * from "./BasicLayout.vue?vue&type=script&lang=js&"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=19879fe5&lang=less&scoped=true&"
import style1 from "./BasicLayout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19879fe5",
  null
  
)

export default component.exports